export default "__VITE_ASSET__5c64ec7b__"